import React from 'react';
import { Link } from 'react-router-dom'; // Import Link for internal routing
import styles from "./cartitem.module.css";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrashAlt } from '@fortawesome/free-solid-svg-icons';
import { useTranslation } from "react-i18next";
import ImageWithFallback from '../ImageWithFallback';
import { formatPrice } from '../../utils/product';

const CartItem = ({
  productImage,
  productTitle,
  shopName,
  productLink, // This should be the productId or slug
  productAlt,
  metadata,
  price,
  quantity,
  totalPrice,
  selected,
  onSelect,
  onDecrease,
  onIncrease,
  onQuantityChange,
  onDelete,
}) => {
  const { t } = useTranslation();

  return (
    <div className="d-flex align-items-start p-3 border-bottom">
      <div className="col-1 d-flex justify-content-center">
        <input
          type="checkbox"
          checked={selected}
          onChange={onSelect}
          aria-label={`Select ${productTitle}`}
        />
      </div>
      <div className="col-3 d-flex align-items-start">
        <Link title={productTitle} to={`/product/${productLink}`}> {/* Use Link for internal navigation */}
          <ImageWithFallback
            className={`img-fluid ${styles.detailImg}`}
            src={productImage}
            alt={productAlt}
          />
        </Link>
        <div className="d-flex flex-column ms-3">
          <Link
            className={styles.productName}
            title={productTitle}
            to={`/product/${productLink}`} // Use Link for internal navigation
          >
            {productTitle}
          </Link>
          <Link className={styles.shopName} title={shopName} to={`/product/${productLink}`}>
            {shopName}
          </Link>
        </div>
      </div>
      <div className="col-2">
        <div className={styles.categoryButton}>
          <div className={styles.categoryDetails}>
            {metadata.map((data) => (
              <p>{data.attribute}: {data.value}</p>
            ))}
          </div>
        </div>
      </div>
      <div className="col-1 text-center">
        <div>
          <span className="d-block">{formatPrice(price)}</span>
        </div>
      </div>
      <div className="col-2 d-flex align-items-center">
        <button className={styles.quantityButton} aria-label="Decrease" onClick={onDecrease}>
          <svg enableBackground="new 0 0 10 10" viewBox="0 0 10 10" x="0" y="0" className={styles.quantityDecrease}>
            <polygon points="4.5 4.5 3.5 4.5 0 4.5 0 5.5 3.5 5.5 4.5 5.5 10 5.5 10 4.5"></polygon>
          </svg>
        </button>
        <input
          className={`form-control mx-2 text-center ${styles.font}`}
          type="number"
          value={quantity}
          onChange={(e) => onQuantityChange(Number(e.target.value))}
          aria-label="Quantity"
        />
        <button className={styles.quantityButton} aria-label="Increase" onClick={onIncrease}>
          <svg enableBackground="new 0 0 10 10" viewBox="0 0 10 10" x="0" y="0" className={styles.quantityIncrease}>
            <polygon points="10 4.5 5.5 4.5 5.5 0 4.5 0 4.5 4.5 0 4.5 0 5.5 4.5 5.5 4.5 10 5.5 10 5.5 5.5 10 5.5"></polygon>
          </svg>
        </button>
      </div>
      <div className="col-1 text-end align-items-center">
        <span className={`d-block ${styles.total}`}>{formatPrice(totalPrice)}</span>
      </div>
      <div className="col-2 d-flex flex-column align-items-center px-3">
        <button className={styles.interactBoxTop} onClick={onDelete}>
          <FontAwesomeIcon icon={faTrashAlt} style={{ color: 'red' }} />
        </button>
      </div>
    </div>
  );
};

export default CartItem;
